/* eslint-disable no-shadow */
import {
  GetterTree, MutationTree, ActionTree, Module
} from 'vuex';
import { settlementCalculatorService } from '@/services/SettlementCalculatorService';
import FinanceSettlementRequest from '@/models/finance/FinanceSettlementRequest';
import FinanceSettlementResult from '@/models/finance/FinanceSettlementResult';
// eslint-disable-next-line import/no-cycle
import { validationService } from '@/services/ValidationService';
import IRootState from '../states/interfaces/index.d';
import IFinanceSettlementState from '../states/interfaces/finance-settlement-state.d';
import FinanceSettlementState from '../states/finance-settlement-state';

export const state: IFinanceSettlementState = new FinanceSettlementState();

export const getters: GetterTree<IFinanceSettlementState, IRootState> = {
  settlementRequest: (state) => state.financeSettlementRequest,
  contractStartDateString: (state) => state.contractStartDateString,
  formattedContractStartDate: (state) => state.formattedContractStartDate,
  settlementResult: (state) => state.financeSettlementResult
};

export const mutations: MutationTree<IFinanceSettlementState> = {
  setFinanceSettlementResult: (state: FinanceSettlementState, financeSettlement: FinanceSettlementResult) => {
    state.financeSettlementResult = financeSettlement;
  },
  setContractDateString: (state: FinanceSettlementState, contractStartDateString: string) => {
    state.contractStartDateString = contractStartDateString;
  },
  setFormattedContractStartDate: (state: FinanceSettlementState, formattedContractStartDate: Date) => {
    state.formattedContractStartDate = formattedContractStartDate;
  }
};

export const actions: ActionTree<IFinanceSettlementState, IRootState> = {
  submitContractStartDate: ({ commit }, contractStartDateString: string) => {
    commit('setContractDateString', contractStartDateString);
    return new Promise((resolve) => {
      validationService.formattedDate(contractStartDateString)
        .then((value) => {
          commit('setFormattedContractStartDate', value);
          resolve(value);
        });
    });
  },
  retrieveSettlement({ state, commit }, financeSettlementRequest: FinanceSettlementRequest) {
    financeSettlementRequest.contractStartDate = state.formattedContractStartDate;
    financeSettlementRequest.settlementDate = new Date();
    return new Promise((resolve) => {
      settlementCalculatorService.getFinanceSettlement(financeSettlementRequest)
        .then((value) => {
          if (value.success && value.result !== null) {
            commit('setFinanceSettlementResult', value.result);
          }
          resolve(value.resultType);
        });
    });
  }
};

export const financeSettlementModule: Module<IFinanceSettlementState, IRootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
